// Shared helper to turn an axios/API error into a plain string.
export function apiErrorMessage(err, fallback = 'Something went wrong') {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || 'Invalid value').join(', ');
  if (d && typeof d === 'object') return d.msg || fallback;
  return err?.message || fallback;
}
